export const HomeServiceConstant = {
    API: 'Home'
}

export const HomeAPIServiceConstant = {
    GET_DROPDOWN_PLANTS_AND_WAREHOUSE: HomeServiceConstant.API + '/GetDropDownPlantsAndWarehouse',
    GET_MATERIAL_DETAILS: HomeServiceConstant.API + '/GetMaterialDetails',
}